import {styled} from "@mui/material/styles";
import {TableCell, TableRow} from "@mui/material";

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: 10,
  "&:hover": {
    background: "#F2F9F5",
  },
}));

export const TableRowStyled = styled(TableRow)(({ theme }) => ({
  cursor: "pointer",
}));
